/* eslint-disable @angular-eslint/no-output-on-prefix */
import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';

@Component({
	selector: 'app-confirmation-popup',
	templateUrl: './confirmation-popup.component.html',
	styleUrls: ['./confirmation-popup.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class ConfirmationPopupComponent {
	@Input() isDisplay = false;
	@Output() isDisplayChange = new EventEmitter<boolean>();
	@Output() onClickYes = new EventEmitter();
	@Output() onClickOption1 = new EventEmitter();
	@Output() onClickOption2 = new EventEmitter();
	@Output() onClickNo = new EventEmitter();
	@Input() header = '';
	@Input() customHeader: any;
	@Input() check = '';
	@Input() warning = ''
	@Input() message = '';
	@Input() icon: any;
	@Input() yes: any;
	@Input() ok: any;
	@Input() no: any;

	constructor(private cdr: ChangeDetectorRef) { }

	// On Click Yes
	clickYes() {
		this.close();
		this.onClickYes.emit(true);
	}

	// On click Option 1 (For more than one "Yes" options)
	clickOption1() {
		this.close();
		this.onClickOption1.emit(true);
	}

	// On click Option 2 (For more than one "Yes" options)
	clickOption2() {
		this.close();
		this.onClickOption2.emit(true);
	}

	// On click No
	clickNo() {
		this.close();
		this.onClickNo.emit(true);
	}

	// To close model.
	close() {
		this.isDisplay = false;
		// this.onClickNo.emit(true);
		this.isDisplayChange.emit(this.isDisplay);
		this.cdr.markForCheck();
	}

	clickYesForFlexFilePopUp() {
		this.onClickYes.emit(true);
	}
}
